export default Object.freeze({
  editAlarm: 'alarmsClassification.editAlarm',
  clearSearch: 'alarmsClassification.clearSearch',
});
